import React, { useState, useEffect } from "react";
import axios from "axios";
import {
    Button,
    FormField,
    StandardModal,
    StandardModalActionGroup,
    StandardModalDescription,
    StandardModalFormGroup,
    StandardModalSection,
    StandardModalSectionTitle,
    Toast
} from "src/components";
import styled from "styled-components";
import { API_URL } from "src/scenes/App";

const StyledTitleInput = styled(FormField)`
    border: 1px solid #8291b2;
    border-radius: 12px;
    text-align: left;
    font-family: Manrope, Helvetica, sans-serif;
    font-weight: 400;
    font-size: 1rem;
    color: #000;
    width: 364px;
    max-width: 100%;
    height: 50px;
    box-sizing: border-box;
    box-shadow: none;

    ::placeholder {
        text-align: left;
        color: #808080;
        font-family: Manrope, Helvetica, sans-serif;
    }
`;

const CustomNameModal = ({ handleCloseCustomNameModal, currentCustomName, user, setCustomDirectoryName }) => {

    const [inputValue, setInputValue] = useState(currentCustomName);

    useEffect(() => {
        setInputValue(currentCustomName || "");
    }, [currentCustomName]);

    const handleSave = async () => {
        try {
            await axios.put(`${API_URL}/businessContacts/directory/updateCustomDirectoryName`, 
                { customDirectoryName: inputValue },
                {
                    headers: {
                        Authorization: "Bearer " + user.token,
                        "Content-Type": "application/json"
                    }
                }
            );
            Toast.success("Custom directory name updated successfully.");
            setCustomDirectoryName(inputValue);
            handleCloseCustomNameModal();
        } catch (error) {
            console.error(error);
            Toast.error("Failed to update directory name.");
        }
    };

    // Disable Save button if there are no changes
    const isUnchanged = inputValue.trim() === (currentCustomName || "").trim();

    return (
        <StandardModal
            open={true}
            onClose={handleCloseCustomNameModal}
            title="Custom Directory Name"
            description="Set a custom name for your Directory feature in the Me Business app and portal. This allows you to personalise how the feature is labelled (e.g., “Team Directory” or “Staff Contacts”) to better reflect your organisation’s language and structure."
            widthMode="medium"
            footer={(
                <StandardModalActionGroup $pushRight>
                    <Button
                        onClick={handleCloseCustomNameModal}
                        size="0.875rem"
                        border="1px solid #000"
                        color="#000"
                        width="8.75rem"
                        style={{ borderRadius: "7px", boxShadow: "none" }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleSave}
                        size="0.875rem"
                        backgroundColor={isUnchanged ? "#d3d3d3" : "#171A22"}
                        border={`1px solid ${isUnchanged ? "#d3d3d3" : "#171A22"} `}
                        color={isUnchanged ? "#888" : "#fff"}
                        width="8.75rem"
                        disabled={isUnchanged}
                        style={{ borderRadius: "7px", boxShadow: "none", cursor: isUnchanged ? "not-allowed" : "pointer" }}
                    >
                        Save
                    </Button>
                </StandardModalActionGroup>
            )}
        >
            <StandardModalSection>
                <StandardModalFormGroup>
                    <StandardModalSectionTitle>Create a Custom Directory Name (Optional)</StandardModalSectionTitle>
                    <StandardModalDescription>
                    This title will replace the default name ‘Directory’ in both the app and business portal. If you don’t enter a custom name, the feature will remain as ‘Directory’.
                    </StandardModalDescription>
                    <StyledTitleInput
                        name="CustomDirectoryName"
                        value={inputValue}
                        placeholder="e.g. Team Directory"
                        onChange={(e) => setInputValue(e.target.value)}
                    />
                </StandardModalFormGroup>
            </StandardModalSection>
        </StandardModal>
    );
};

export default CustomNameModal;
